<!-- 朋友圈SOP添加 -->
<template>
  <div>
    <el-page-header class="page-header" @back="goBack" content="朋友圈SOP">
    </el-page-header>
    <div class="container Mmain">
      <el-form ref="form" :model="form" :rules="rules" label-width="12.0rem">
        <el-form-item label="规则名称:" prop="name">
          <el-input
            clearable
            style="width: 47.0rem"
            placeholder="请输入规则名称"
            v-model="form.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="SOP周期:" prop="period">
          <el-radio-group v-model="form.period">
            <el-radio :label="1">每日</el-radio>
            <el-radio :label="2">每周</el-radio>
            <el-radio :label="3">每月</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="执行员工:" prop="userid">
          <div class="person" v-if="user.length">
            <el-tag
              v-for="(item, index) of user"
              style="margin: 0 rem 1.2rem 0 0"
              
              effect="plain"
              :key="index"
            >
              {{ item.name }}
            </el-tag>
          </div>
          <el-button
            :style="{ marginTop: user.length > 0 ? '.8rem' : '0' }"
            
            plain
            icon="el-icon-plus"
            @click="onSelectPerson"
            >选择执行员工</el-button
          >
        </el-form-item>
        <el-form-item label="推送要求:" prop="content">
          <div class="checkbox-box">
            <el-checkbox
              class="checkbox-check"
              v-model="form.corp_moment"
            ></el-checkbox>
            企业圈，每日员工需发布<el-input-number
              class="checkbox-iptnum"
              v-model="form.corp_moment_num"
              controls-position="right"
              :min="1"
              size="mini"
            ></el-input-number
            >篇企业圈内容
          </div>
          <div class="checkbox-box">
            <el-checkbox class="checkbox-check" v-model="form.history_moment">
            </el-checkbox>
            企业微信客户朋友圈，每日员工需发布<el-input-number
              class="checkbox-iptnum"
              v-model="form.history_moment_num"
              controls-position="right"
              :min="1"
              size="mini"
            ></el-input-number
            >篇客户朋友圈内容
          </div>
          <div class="checkbox-box">
            <el-checkbox
              class="checkbox-check"
              v-model="form.wechat_moment"
            ></el-checkbox>
            个人微信朋友圈，每日员工需发布
            <el-input-number
              class="checkbox-iptnum"
              v-model="form.wechat_moment_num"
              controls-position="right"
              :min="1"
              size="mini"
            ></el-input-number>
            篇个人微信朋友圈内容
          </div>
        </el-form-item>
        <el-form-item label="监督人:" prop="check_userid">
          <div class="person">
            <el-tag
              v-if="check_user.name"
              style="margin: .0rem 1.2rem 0 0"
              
              effect="plain"
            >
              {{ check_user.name }}
            </el-tag>
          </div>
          <el-button
            :style="{ marginTop: check_user.name ? '.8rem' : '0' }"
            
            plain
            icon="el-icon-plus"
            @click="onSelectCheckPerson"
            >选择监督人</el-button
          >
        </el-form-item>
      </el-form>
      <div class="form-footer">
        <el-button v-if="this.$route.query.id" type="primary" @click="submit" :disabled="isLock">确定编辑</el-button>
        <el-button v-else type="primary" @click="submit" :disabled="isLock">立即创建</el-button>
        <!-- <el-button @click="goBack">取消</el-button> -->
      </div>
    </div>
    <right-people ref="dialog" :selectData="selectData" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>

<script>
import rightPeople from '@/components/drawer/rightPeople';
export default {
  name: "friendSopDetail",
  components: {
    rightPeople
  },
  data() {
    return {
      isLock:false,//控制创建按钮状态
      selectData: [],
      form: {
        name: "",
        period: 1,
        userid: "",
        check_userid: "",
        content: "",
        corp_moment: true,
        history_moment: true,
        wechat_moment: true,
        corp_moment_num: 1,
        history_moment_num: 1,
        wechat_moment_num: 1,
      },
      rules: {
        name: [{ required: true, message: "请输入规则名称", trigger: "blur" }],
        period: [{ required: true, message: "请选择SOP周期", trigger: "blur" }],
        userid: [
          { required: true, message: "请选择执行员工", trigger: "blur" },
        ],
        check_userid: [
          { required: true, message: "请输入监督人", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请填写推送要求", trigger: "blur" },
        ],
      },
      module: "",
      checkbox: false,
      user: [],
      check_user: {},
    };
  },

  computed: {},

  mounted() {
    if (this.$route.query.id) {
      this.getData();
    }
  },

  methods: {
    async getData() {
      this.form.corp_moment = false;
      this.form.history_moment = false;
      this.form.wechat_moment = false;
      const { data: res } = await this.axios({
        url: "/crm/CircleFriendsSop/getListone",
        method: "POST",
        data: this.qs.stringify({
          usertoken: this.tooken.usertoken,
          account_id: this.tooken.account_id,
          phone: this.tooken.phone,
          id: this.$route.query.id,
        }),
      });
      console.log(res);
      if (res.code == 1) {
        const data = res.data;
        const content = data.content;
        this.form.name = data.name;
        this.form.period = data.period;
        this.form.userid = data.userid;
        this.form.content = content;
        this.form.check_userid = data.check_userid;
        const userid = data.userid.split(',');
        this.user = data.userid_name.map((i,index) => {
          return {
            name: i,
            id: userid[index]
          };
        });
        this.check_user = {
          name: data.check_userid_name,
        };
        for (let index = 0; index < content.length; index++) {
          const element = content[index];
          if (element.title === "企业圈") {
            this.form.corp_moment = true;
            this.form.corp_moment_num = element.count;
          }
          if (element.title === "企微客户朋友圈") {
            this.form.history_moment = true;
            this.form.history_moment_num = element.count;
          }
          if (element.title === "个人微信朋友圈") {
            this.form.wechat_moment = true;
            this.form.wechat_moment_num = element.count;
          }
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    submit() {
      let content = [];
      this.form.content = "";
      if (this.form.corp_moment) {
        content.push({
          title: "企业圈",
          count: this.form.corp_moment_num,
        });
      }

      if (this.form.history_moment) {
        content.push({
          title: "企微客户朋友圈",
          count: this.form.history_moment_num,
        });
      }

      if (this.form.wechat_moment) {
        content.push({
          title: "个人微信朋友圈",
          count: this.form.wechat_moment_num,
        });
      }
      if (content.length > 0) {
        this.form.content = JSON.stringify(content);
      }

      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.isLock = true
          this.submitForm();
          setTimeout(()=>{
            this.isLock = false
          },1000)
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async submitForm() {
      let url = "/crm/CircleFriendsSop/add";
      const params = {
        account_id: this.tooken.account_id,
        phone: this.tooken.phone,
        name: this.form.name,
        userid: this.form.userid,
        check_userid: this.form.check_userid,
        period: this.form.period,
        content: this.form.content,
      };
      if (this.$route.query.id) {
        url = "/crm/CircleFriendsSop/edit";
        params.id = this.$route.query.id;
      }
      const { data: res } = await this.axios({
        url,
        method: "POST",
        data: this.qs.stringify(params),
      });
      if (res.code == 1) {
        this.goBack();
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    handleSelect(person) {
      if (this.checkbox) {
        this.user = person;
        const userid = this.user.map((i) => {
          return i.userid;
        });
        this.form.userid = String(userid);
      } else {
        this.check_user = person;
        this.form.check_userid = this.check_user.userid;
      }
    },
    onSelectPerson() {
      this.selectData = this.user;
      this.checkbox = true;
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
    onSelectCheckPerson() {
      this.selectData = this.check_user;
      this.checkbox = false;
      this.module = "getAddressBook";
      this.$refs.dialog.open();
    },
  },
};
</script>
<style  lang="scss" scoped>
.Mmain {
  padding-top:4rem;
  background-color: #fff;
  border-radius: 0.8rem;
  padding-left: 2.0rem;
  padding-bottom:2.0rem
}
.checkbox {
  display: flex;
  margin: 2.0rem 0;
  align-items: center;
  &-iptnum {
    margin: 0 1.2rem;
  }
  &-check {
    padding-right: .6rem;
  }
}
.form-footer {
  padding-left:2.5rem;
  padding-top:2.0rem
}
.el-page-header{
  position: relative;
  top: -.4rem;
}
.el-form-item {
    margin-bottom: 4.0rem;
}




</style>